import React, { useState } from 'react';
import celular from '../../imagenes/celular.png'
import './Auth.css';

const PhoneVerification = ({ setAuthStep }) => {
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [phone, setPhone] = useState('');

  const handleCodeChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      
      // Auto-focus next input
      if (value && index < 5) {
        document.getElementById(`code-${index + 1}`).focus();
      }
    }
  };

  const handleVerify = () => {
    setAuthStep('verified');
  };

  const handleResend = () => {
    // Lógica para reenviar código
    alert('New code sent!');
  };

  return (
    <div className="auth-container">
      <div className="auth-header">
        <h2>Verifica tu número</h2>
        <p>Te enviamos un SMS con el código de verificación</p>
      </div>

          <img className='hombre2'
          src={celular}alt='dibujo de celular'  
          />
      
      <div className="auth-form">
        <div className="input-group">
          <label>Phone Number</label>
          <input 
            type="tel" 
            placeholder="Enter your phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        
        <div className="code-inputs">
          {code.map((digit, index) => (
            <input
              key={index}
              id={`code-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleCodeChange(index, e.target.value)}
              className="code-input"
            />
          ))}
        </div>
        
        <button className="auth-btn primary" onClick={handleVerify}>
          Verify
        </button>
        
        <div className="resend-section">
          <p>¿No recibiste ningún código?</p>
          <button className="auth-link" onClick={handleResend}>
            Reenviar nuevo código
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhoneVerification;